import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);

  return toObservable(inject(AuthService).authenticated).pipe(
    take(1),
    map((authenticated) => (authenticated ? true : router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }))),
  );
};
